export default __webpack_public_path__ + "2448776bbc53c18588d801c6d85f1ee7.jpg";